import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';
import './RevertConfirmationModal.css';
import { useEligibilityTheme } from '../../../hooks/useEligibilityEngine'; // adjust the path as needed

const RevertConfirmationModal = ({
  open, onClose, onConfirm,
}) => {
  const { themeClass } = useEligibilityTheme();

  return (
    <Modal
      open={open}
      onClose={onClose}
      size='small'
      data-testid='revert-confirmation-modal'
      className={`theme ${themeClass}`}
    >
      <Modal.Header>Revert Changes</Modal.Header>
      <Modal.Content>
        <p>
          Are you sure you want to revert all unsaved changes? This action cannot
          be undone.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} data-testid='revert-cancel-button'>
          Cancel
        </Button>
        <Button
          className='revert-confirm-btn'
          onClick={onConfirm}
          data-testid='revert-confirm-button'
          primary
        >
          Revert
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

RevertConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default RevertConfirmationModal;
